
import { Vue } from "vue-class-component";

export default class Duplicate extends Vue {}
